import { render } from "./FixedNavigation.vue?vue&type=template&id=5815697f&scoped=true&lang=pug&bindings={}"
import script from "./FixedNavigation.vue?vue&type=script&lang=js"
export * from "./FixedNavigation.vue?vue&type=script&lang=js"

import "./FixedNavigation.vue?vue&type=style&index=0&id=5815697f&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5815697f"

export default script